export default {
    computed: {
        frequencies() {
            const { frequencies } =
                this.$store.getters['company/assetFrequencies']
            return (frequencies || []).map(({ name, value: id }) => ({
                name,
                id,
            }))
        },
        weekDays() {
            return [
                { id: 0, name: 'Sunday' },
                { id: 1, name: 'Monday' },
                { id: 2, name: 'Tuesday' },
                { id: 3, name: 'Wednesday' },
                { id: 4, name: 'Thursday' },
                { id: 5, name: 'Friday' },
                { id: 6, name: 'Thursday' },
            ]
        },
    },
    watch: {},
    methods: {
        getLabel(field, isTrueLabel) {
            let label
            if (field === 'customer_id') label = 'Belong To'
            else if (field === 'location_section_id') label = 'Asset Location'
            else {
                const list = field.split('_')
                ///remove last item if equal to id or url
                if (
                    list[list.length - 1] === 'id' ||
                    list[list.length - 1] === 'url'
                ) {
                    list.pop()
                }
                label = list
                    .map(
                        x =>
                            x.slice(0, 1).toUpperCase() +
                            x.slice(1).toLowerCase()
                    )
                    .join('  ')
            }
            const obj = this.dataItems.find(x => x.field === field)
            return `${label}${isTrueLabel && obj.required ? '*' : ''}`
        },
        getOptions(field) {
            const arr = (() => {
                switch (field) {
                    case 'manufacturer_id':
                        return this.vendors || []
                    case 'vendor_id':
                        return this.vendors || []
                    case 'type_id':
                        return this.types || []
                    case 'customer_id':
                        return this.customers || []
                    case 'frequency':
                        return this.frequencies
                    case 'service_week_day':
                        return this.weekDays
                    case 'default_engineer_id':
                        return this.engineers
                    case 'order_template_id':
                        return this.orderTypes
                }
            })()

            return arr.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },
        getValue(field, asset) {
            switch (field) {
                case 'manufacturer_id':
                    return asset.manufacturer.name
                case 'vendor_id':
                    return asset.vendor.name
                case 'customer_id':
                    return asset.customer.name
                case 'type_id':
                    return asset.type.name
                case 'frequency':
                    return (
                        this.frequencies.find(x => x.id === asset[field]) || {}
                    ).name
                case 'location_section_id':
                    return asset.location_section.name
                case 'manual_url':
                case 'service_plan_url':
                case 'image_url': {
                    try {
                        return JSON.parse(asset[field])
                    } catch (err) {
                        //console.log('err', err)
                        return { name: asset[field], key: asset[field] }
                    }
                }
                default:
                    return asset[field]
            }
        },
    },
}
